<template>
  <div>
    <button-options
      :access="access"
      :hideAdd="true"
      :hideDelete="false"
      :hideDetail="false"
      :hideEdit="false"
      @onDeleteClicked="onDeleteClicked"
      @onEditClicked="onEditClicked"
      @onViewClicked="onViewClicked"/>
  </div>
</template>

<script>
import ButtonOptions from '../directives/button-options';

export default {
  name: 'GroupEdit',
  components: { ButtonOptions },
  props: ['access', 'group'],
  data() {
    return {
      isSubmit: false,
    };
  },
  computed: {
    data() {
      return { ...this.group };
    },
  },
  methods: {
    onDeleteClicked() {
      this.$emit('onDeleteClicked', this.data);
    },
    onEditClicked() {
      this.$emit('onEditClicked', this.data);
    },
    onViewClicked() {
      this.$emit('onViewClicked', this.data);
    },
  },
};
</script>

<style scoped>

</style>
